import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import newsletterConfig from 'lib/newsletter.json';
import verticalName from 'lib/verticalName';
import ButtonHoverAnimation from 'components/ButtonHoverAnimation';

import styles from './styles.module.scss';

// Get a newsletter config
export function getNLConfig(vertical, section) {
  const config = newsletterConfig[vertical] || newsletterConfig.news;
  return config[section] || config.default;
}

// Get a newsletter configuration value
export function getNLValue(vertical, key = 'url', section = 'default') {
  const config = getNLConfig(vertical, section);
  return typeof config[key] !== 'undefined' ? config[key] : false;
}

function getNLSignupTitle(vertical, section) {
  const signupTitle = getNLValue(vertical, 'signupTitle', section);
  if (signupTitle) {
    return (
      <h2 className={styles.signupTitle}>
        {signupTitle}
      </h2>
    );
  }
  return null;
}

function getNLSignupMessage(vertical, section) {
  const signupMessage = getNLValue(vertical, 'signupMessage', section);
  return signupMessage || `${i18next.t('Get the')} ${verticalName(vertical)} ${i18next.t('newsletter')}.`;
}

function NewsletterSignup({ vertical, section }, { amp }) {
  if (amp) {
    return null;
  }

  if (section && ['nbc-out', 'nbcblk', 'latino', 'asian-america'].indexOf(section) > -1) {
    return null;
  }

  return (
    <div
      className={classnames(styles.container, 'dn-print')}
      data-test="newsletter-signup"
    >
      <div className={styles.borderTop} />
      <div className={styles.borderLeft} />

      <div className={styles.signupBackground}>
        {getNLSignupTitle(vertical, section)}

        <div className={styles.signupForeground}>
          <div className={styles.signupMessage}>
            {getNLSignupMessage(vertical, section)}
          </div>

          <ButtonHoverAnimation
            size="normal"
            buttonStyle={styles.signupButton}
            title={i18next.t('SUBSCRIBE')}
            type="link"
            url={getNLValue(vertical, 'url', section)}
            target="_blank"
          />
        </div>
      </div>
    </div>
  );
}

NewsletterSignup.propTypes = {
  vertical: PropTypes.string.isRequired,
  section: PropTypes.string,
};

NewsletterSignup.defaultProps = {
  section: null,
};

NewsletterSignup.contextTypes = {
  amp: PropTypes.bool,
};

export default NewsletterSignup;
